import { Crunchbase, Global, Linkedin, Twitter } from '@clearkit/icons';
import classNames from 'classnames';
import { CKCompanyLogo, CKTooltip } from 'clearkit';

const CompanyNameAndSocialIconsCell = ({
  domain,
  name,
  loading,
  loadingEnrichment,
  twitter,
  linkedin,
  crunchbase,
}: {
  domain: string;
  name?: string;
  loading: boolean;
  loadingEnrichment: boolean;
  twitter?: string;
  linkedin?: string;
  crunchbase?: string;
}) => {
  const displayName = name || domain;

  return (
    <div className="flex items-center col-span-5 gap-4">
      <CKCompanyLogo
        className={classNames('flex-shrink-0', {
          'ck-skeleton': loading,
        })}
        domain={loading ? undefined : domain}
        size={28}
      />

      <div className="flex flex-col items-start truncate gap-px text-ellipsis whitespace-nowrap">
        <span
          className={classNames(
            'font-semibold transition-color duration-200 group-hover:text-blue-500 text-black',
            {
              'ck-skeleton': loading,
            },
          )}
        >
          {displayName}
        </span>

        <div className="flex items-center gap-1.5">
          <CKTooltip
            hasHover={!loading}
            placement="bottom"
            tooltip={`Open ${domain} in a new window`}
            tooltipMaxWidth="240px"
          >
            <a
              className={classNames(
                'text-gray-300 hover:text-blue-500 duration-200 transition-all',
                { 'ck-skeleton bg-gray-500': loading },
              )}
              href={`https://${domain}`}
              onClick={(e) => e.stopPropagation()}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Global className="w-[14px] h-[14px]" />
            </a>
          </CKTooltip>

          {loadingEnrichment ? (
            <span className="w-[14px] h-[14px] ck-skeleton" />
          ) : (
            <>
              {linkedin && (
                <a
                  className="text-gray-300 hover:text-blue-500 duration-200 transition-all"
                  href={`https://www.linkedin.com/${linkedin}`}
                  onClick={(e) => e.stopPropagation()}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Linkedin className="w-[14px] h-[14px]" />
                </a>
              )}

              {crunchbase && (
                <a
                  className="text-gray-300 hover:text-blue-500 duration-200 transition-all"
                  href={`https://www.crunchbase.com/${crunchbase}`}
                  onClick={(e) => e.stopPropagation()}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Crunchbase className="w-[14px] h-[14px]" />
                </a>
              )}

              {twitter && (
                <a
                  className="text-gray-300 hover:text-blue-500 duration-200 transition-all"
                  href={`https://twitter.com/${twitter}`}
                  onClick={(e) => e.stopPropagation()}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Twitter className="w-[14px] h-[14px]" />
                </a>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyNameAndSocialIconsCell;
